<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import TreeNode from './TreeNode.svelte';
  import { FontAwesomeIcon } from "@fortawesome/svelte-fontawesome";
  import { faChevronDown, faChevronRight } from "@fortawesome/free-solid-svg-icons";

  export let node: any;
  export let path: string;
  let expanded = true;

  const dispatch = createEventDispatcher<{
    documentClick: { documentId: string; documentTitle: string };
  }>();

  function handleDocumentClick(documentId: string, documentTitle: string) {
    dispatch('documentClick', { documentId, documentTitle });
  }

  function handleChildDocumentClick(event: CustomEvent<{ documentId: string; documentTitle: string }>) {
    dispatch('documentClick', event.detail);
  }
</script>

<li class="doc-tree-node">
  {#if node.children}
    <div 
      class="doc-tree-label section" 
      role="button"
      tabindex="0"
      on:click={() => expanded = !expanded}
      on:keydown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          expanded = !expanded;
        }
      }}
    >
        {#if expanded}
          <FontAwesomeIcon icon={faChevronDown} class="w-3 h-3 ml-1 text-primary-50" />
        {:else}
          <FontAwesomeIcon icon={faChevronRight} class="w-3 h-3 ml-1 text-primary-50" />
        {/if}
        {node.label}
    </div>
    {#if expanded}
      <ul class="ml-2">
        {#each node.children as child, j}
          <TreeNode node={child} path={`${path}-${j}`} on:documentClick={handleChildDocumentClick} />
        {/each}
      </ul>
    {/if}
  {:else}
    <div class="doc-tree-label leaf">
      {#if node.link && node.link !== "#"}
        <a 
          href={node.link} 
          class="doc-link ml-2" 
          target="_blank"
          on:click|stopPropagation
        >
          {node.label}
        </a>
      {:else if node.link === "#" || !node.link}
        <a 
          href="javascript:void(0)" 
          class="doc-link ml-2"
          on:click|preventDefault|stopPropagation={() => {
            // Use node.label as documentId for now, or extract from node if available
            const documentId = node.documentId || node.id || node.label;
            const documentTitle = node.label;
            handleDocumentClick(documentId, documentTitle);
          }}
        >
          {node.label}
        </a>
      {:else}
        {node.label}
      {/if}
    </div>
  {/if}
</li>

<style>

</style> 